import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'config/i18n';
// Material UI Core
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
// Material UI icons
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: [theme.zIndex.modal + 1, '!important'],
  },
  paper: {
    width: theme.typography.pxToRem(600),
    maxHeight: '80vh',
    backgroundColor: theme.palette.background.default,
    color: theme.palette.secondary.main,
  },
  message: {
    margin: theme.spacing(0.8, 0, 2.5),
    lineHeight: 1.6,
    fontSize: '120%',
  },
}));

const PrivacyPolicyDialog = (props) => {
  const classes = useStyles();
  const { onClose, open, t } = props;

  const handleCancel = () => {
    // when dialog is closed
    onClose();
  };

  return (
    <Dialog
      onClose={handleCancel}
      id="privacy-policy"
      open={open}
      classes={{
        root: classes.root,
        paper: classes.paper,
      }}
      maxWidth="md"
      keepMounted
    >
      <DialogTitle>
        <Typography variant="h6">
          {t('layout:footer.er_privacy_policy')}
        </Typography>
        <IconButton
          onClick={handleCancel}
          aria-label="Cancel"
          color="secondary"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography className={classes.message}>
          {t('layout:footer.privacy_policy_content')}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

PrivacyPolicyDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default withTranslation(['layout'])(PrivacyPolicyDialog);
